import { createApi } from "@reduxjs/toolkit/query/react";
import { queryParams } from "../../../utils/helper";
import { baseQueryWithAuth } from "../../BaseQueryWithAuth/baseQueryWithAuth";

export const mediaTranscriptApiService = createApi({
  reducerPath: "mediaTranscriptApi",
  baseQuery: baseQueryWithAuth,
  endpoints: (builder) => ({
    generateMediaTranscript: builder.mutation({
      query: ({ body, params }) => {
        let query = queryParams(params);
        return {
          url: `media-transcript/generate${query}`,
          method: "POST",
          body,
        };
      },
    }),
    reGenerateMediaTranscript: builder.mutation({
      query: ({ id, params }) => {
        let query = queryParams(params);
        return {
          url: `media-transcript/${id}/regenerate${query}`,
          method: "POST",
        };
      },
    }),
    getMediaTranscriptById: builder.query({
      query: ({ id, params }) => {
        let query = queryParams(params);
        return {
          url: `media-transcript/${id}${query}`,
          method: "GET",
        };
      },
    }),
    updateMediaTranscript: builder.mutation({
      query: ({ id, body, params }) => {
        let query = queryParams(params);
        return {
          url: `media-transcript/${id}${query}`,
          method: "PUT",
          body,
        };
      },
    }),
    getByTranscriptMediaId: builder.query({
      query: ({ params }) => {
        let query = queryParams(params);
        return {
          url: `media-transcript${query}`,
          method: "GET",
        };
      },
    }),
    getbulkMediaTranscript: builder.query({
      query: ({ body, params }) => {
        let query = queryParams(params);
        return {
          url: `media-transcript/bulk${query}`,
          method: "POST",
          body,
        };
      },
    }),
  }),
});

export const {
  useGenerateMediaTranscriptMutation,
  useReGenerateMediaTranscriptMutation,
  useGetMediaTranscriptByIdQuery,
  useLazyGetMediaTranscriptByIdQuery,
  useUpdateMediaTranscriptMutation,
  useGetByTranscriptMediaIdQuery,
  useGetbulkMediaTranscriptQuery,
} = mediaTranscriptApiService;
